import React, { Component } from "react";
import Amplify from "aws-amplify";
import { connect } from "react-redux";
import { Button } from "react-bootstrap";
import { bindActionCreators } from "redux";
import { toast } from 'react-toastify';
// API Urls
import APIUrls from "../../constants/ApiUrls";
import { APIManager } from "../../utils/api";
import { loginSuccess } from "../../actions/auth";
import "./ConfirmVerification.scss";
import { codeAndParamsFromUrl, addEventNameToEndpoint } from "../../utils/common";

const authSettings = {
  mandatorySignIn: false,
  region: "us-west-2",
  userPoolId: "us-west-2_X9qh8CBP6",
  identityPoolId: "us-west-2:0b763a53-720d-440d-a083-983740ec27d1",
  userPoolWebClientId: "g9g7hl6e7mlhauhg4nff6fs53",
};

const analyticsSettings = {
  disabled: true,
  autoSessionRecord: true,
  AWSPinpoint: {
    appId: process.env.REACT_APP_PINPOINT_ID, 
    region: 'us-east-1',
    endpoint: {
      attributes: {
      },
      channelType: "EMAIL",
      optOut: 'NONE',
      userId: "",
      userAttributes: {
      }
    },
  }
};

const configureAnalytics = async (user) => {
  const { userId, tenantId, email, companyName, emailDomain, role } = user;
  
  analyticsSettings.disabled = false;
  analyticsSettings.AWSPinpoint.endpointId = userId;
  analyticsSettings.AWSPinpoint.endpoint.address = email;
  analyticsSettings.AWSPinpoint.endpoint.attributes.tenantId = [tenantId];
  analyticsSettings.AWSPinpoint.endpoint.attributes.eventName = analyticsSettings.AWSPinpoint.endpoint.attributes.eventName || [];
  analyticsSettings.AWSPinpoint.endpoint.userId = userId;
  analyticsSettings.AWSPinpoint.endpoint.userAttributes.tenantId = [tenantId];
  analyticsSettings.AWSPinpoint.endpoint.userAttributes.userId = [userId];
  analyticsSettings.AWSPinpoint.endpoint.userAttributes.companyName = [companyName];
  analyticsSettings.AWSPinpoint.endpoint.userAttributes.emailDomain = [emailDomain];
  analyticsSettings.AWSPinpoint.endpoint.userAttributes.role = [role];
  // not sure if we can configure just Analytics at this point
  Amplify.Analytics.configure(analyticsSettings);
  Amplify.Analytics.autoTrack('session', {
    enable: true,
    attributes: {
      tenantId,
      userId
    },
  });

  Amplify.Analytics.autoTrack('pageView', {
    enable: true,
    eventName: 'user-page-view',
    attributes: {
        tenantId,
        userId
    },
    type: 'SPA',
    getUrl: () => {
      return window.location.origin + window.location.pathname;
    }
  });

  Amplify.Analytics.autoTrack('event', {
    enable: true,
    events: ['click'],
    selectorPrefix: 'data-cc-analytics-',
    provider: 'AWSPinpoint',
    attributes: {
      tenantId,
      userId
    }
  });

  Amplify.Analytics.enable();
};

class ConfirmVerification extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isVerified: false,
      error: null
    };
  }

  async componentDidMount() {
    let { search } = this.props.location;

    if (!search || search === '') {
      this.props.history.push('/login');
    }

    const params = codeAndParamsFromUrl(search);
    const { code, username, email } = params;

    const { tenant } = await this.setUpCognito(email);

    try {
      await Amplify.Auth.confirmSignUp(username, code);
      addEventNameToEndpoint(Amplify.Analytics, 'admin-auth-confirmed');

      Amplify.Analytics.record({
        name: 'admin-auth-confirmed',
        attributes: {
          tenantId: tenant.tenantId,
          userId: tenant.ownerId
        }
      })
      .then(res => {
        // console.log('confirmation event tracking: ', res);
      })
      .catch(error => console.log('confirmation event tracking error: ', error));

      this.setState({ isVerified: true });

      setTimeout(() => {
        this.props.history.push('/login');
      }, 3000);
    } catch (e) {
      this.setState({ error: e.message });

      toast.error('Failed to verify the user: ' + e.message, {
        position: toast.POSITION.TOP_RIGHT
      });
    }
  }

  setUpCognito = async (email) => {
    // lookup tenant for given email
    const data = await APIManager.Instance.call("GET", APIUrls.getTenant(email));
    const { tenant } = data; // TODO clean up return values
    authSettings.userPoolId = tenant.userPoolId;
    authSettings.identityPoolId = tenant.identityPoolId;
    authSettings.userPoolWebClientId = tenant.appClientId;
    const userId = tenant.ownerId;
    const tenantId = tenant.tenantId;
    const emailDomain = email.split('@')[1];

    configureAnalytics({
      userId,
      tenantId,
      email,
      companyName: tenant.companyName,
      emailDomain,
      role: 'admin'
    });

    Amplify.configure({
      Auth: authSettings,
      Analytics: analyticsSettings
    });

    return data;
  }

  render() {
    return (
      <div className="confirm-verification-container">
        {!this.state.error && <h1>{this.state.isVerified ? 'Thanks for verifying!' : 'Confirming your account now...' }</h1>}
        {this.state.error &&
          <div className="text-center">
            <h1>Oh no! An error occured during verification:</h1>
            <h3>{this.state.error}</h3>
            <Button
              variant="outline-danger"
              className="btn btn-outline-danger"
              size="sm"
              onClick={() => this.props.history.push('/signup')}
            >
              GO TO SIGNUP
            </Button>
          </div>
        }
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.auth.tenant
});

const mapDispatchToProps = dispatch => 
  bindActionCreators({
    loginSuccess
  }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmVerification);
